/**
 * An amount in minor units, as money.
 *
 * Minor units all the way from the database, so the division belongs here and
 * nowhere else. `Intl` does the currency's own conventions, including how many
 * decimal places it actually has — which is not always two, and is the bug a
 * hard-coded `/100` ships with.
 */
export function money(minorUnits: number, currency: string): string {
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(
      minorUnits / 100,
    );
  } catch {
    // An unrecognised currency code is a server newer than this build, and a
    // page that throws over one is worse than a page showing the code itself.
    return `${(minorUnits / 100).toFixed(2)} ${currency}`;
  }
}
